let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("78IfZ")).then(() => parcelRequire('8FyNg'));